// src/pages/JsBasicsCourse.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const JsBasicsCourse = () => {
    const { t } = useTranslation();
    const { topic } = useParams(); // Get topic parameter from URL

    // Documentation for each theme
    const content = {
        introduction: (
            <div>
                <h2>{t('jsBasicCourse.introduction')}</h2>
                <p>{t('jsBasicCourse.introductionContent')}</p>
                <h3>{t('jsBasicCourse.whatIsJs')}</h3>
                <p>{t('jsBasicCourse.whatIsJsDescription')}</p>
                <h3>{t('jsBasicCourse.basicSyntax')}</h3>
                <p>{t('jsBasicCourse.basicSyntaxDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`// This is a comment
console.log('Hello, World!');`}
                </pre>
            </div>
        ),
        variables: (
            <div>
                <h2>{t('jsBasicCourse.variables')}</h2>
                <p>{t('jsBasicCourse.variablesContent')}</p>
                <h3>{t('jsBasicCourse.varLetConst')}</h3>
                <p>{t('jsBasicCourse.varLetConstDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`let name = 'John';
const age = 30;
var isStudent = true;`}
                </pre>
            </div>
        ),
        functions: (
            <div>
                <h2>{t('jsBasicCourse.functions')}</h2>
                <p>{t('jsBasicCourse.functionsContent')}</p>
                <h3>{t('jsBasicCourse.functionDeclaration')}</h3>
                <p>{t('jsBasicCourse.functionDeclarationDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`function greet() {
    console.log('Hello!');
}
greet();`}
                </pre>
            </div>
        ),
        objects: (
            <div>
                <h2>{t('jsBasicCourse.objects')}</h2>
                <p>{t('jsBasicCourse.objectsContent')}</p>
                <h3>{t('jsBasicCourse.objectLiteral')}</h3>
                <p>{t('jsBasicCourse.objectLiteralDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`const person = {
    name: 'John',
    age: 30,
    greet() {
        console.log('Hello, ' + this.name);
    }
};
person.greet();`}
                </pre>
            </div>
        ),
        events: (
            <div>
                <h2>{t('jsBasicCourse.events')}</h2>
                <p>{t('jsBasicCourse.eventsContent')}</p>
                <h3>{t('jsBasicCourse.eventListeners')}</h3>
                <p>{t('jsBasicCourse.eventListenersDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`document.getElementById('myButton').addEventListener('click', function() {
    alert('Button clicked!');
});`}
                </pre>
            </div>
        ),
        domManipulation: (
            <div>
                <h2>{t('jsBasicCourse.domManipulation')}</h2>
                <p>{t('jsBasicCourse.domManipulationContent')}</p>
                <h3>{t('jsBasicCourse.selectingElements')}</h3>
                <p>{t('jsBasicCourse.selectingElementsDescription')}</p>
                <h4>{t('jsBasicCourse.example')}</h4>
                <pre>
{`const element = document.querySelector('#myElement');
element.textContent = 'New content!';`}
                </pre>
            </div>
        )
    };

    return (
        <div className="container mt-5">
            {/* Render content based on the selected topic */}
            {content[topic] || <p>{t('jsBasicCourse.notFound')}</p>}
        </div>
    );
};

export default JsBasicsCourse;
